import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromState from './apple-applications.state';
import * as fromReducer from './apple-applications.reducer';
import { AppleApplication } from '@rocksoft/mdm-sdk-v2';

export const selectAppleApplicationState = createFeatureSelector<fromState.AppleApplicationState>('apple-applications');

export const selectAppleApplicationsByBundleId = (bundleIdentifier: string) =>
  createSelector(selectAllAppleApplications, (apps: AppleApplication[]) =>
    apps.find((app) => app.bundleIdentifier === bundleIdentifier)
  );

export const selectAllAppleApplications = createSelector(
  selectAppleApplicationState,
  fromReducer.selectAllAppleApplications
);

export const selectAppleApplicationEntities = createSelector(
  selectAppleApplicationState,
  fromReducer.selectAppleApplicationEntities
);

export const selectAppleApplicationUploadProgress = createSelector(
  selectAppleApplicationState,
  (state: fromState.AppleApplicationState) => state.progress
);

export const selectAppleApplicationsLoaded = createSelector(
  selectAllAppleApplications,
  (apps: AppleApplication[]) => apps && apps.length > 0
);

export const selectAppleApplicationIds = createSelector(
  selectAppleApplicationState,
  fromReducer.selectAppleApplicationIds
);
